"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definitions = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const definitions = require("./EventBase");
__exportStar(require("./BoundaryEvent"), exports);
__exportStar(require("./EndEvent"), exports);
__exportStar(require("./EventBase"), exports);
__exportStar(require("./IntermediateCatchEvent"), exports);
__exportStar(require("./IntermediateThrowEvent"), exports);
__exportStar(require("./StartEvent"), exports);
// NOTE: This is only for backwards compatibility, to avoid a breaking change.
var Definitions;
(function (Definitions) {
    Definitions.ErrorEventDefinition = definitions.ErrorEventDefinition;
    Definitions.EventDefinition = definitions.EventDefinition;
    Definitions.LinkEventDefinition = definitions.LinkEventDefinition;
    Definitions.MessageEventDefinition = definitions.MessageEventDefinition;
    Definitions.SignalEventDefinition = definitions.SignalEventDefinition;
    Definitions.TerminateEventDefinition = definitions.TerminateEventDefinition;
    Definitions.TimerEventDefinition = definitions.TimerEventDefinition;
    Definitions.TimerType = definitions.TimerType;
})(Definitions = exports.Definitions || (exports.Definitions = {}));
//# sourceMappingURL=index.js.map